/*eslint "no-console": "off"*/
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import {ApolloProvider, ApolloClient} from '@apollo/client';
import {InMemoryCache} from '@apollo/client/cache';
import './globals.css';
import {createUploadLink} from 'apollo-upload-client';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter as Router, Routes, Route} from 'react-router';
import {QueryParamProvider} from 'use-query-params';
import {ReactRouter6Adapter} from 'use-query-params/adapters/react-router-6';

import Auth from './views/auth';

const cache = new InMemoryCache({});

const link = createUploadLink({
  uri: '/graphql',
  credentials: 'include',
});

const client = new ApolloClient({
  cache,
  link,
});

const Admin = () => (
  <ApolloProvider client={client}>
    <Router>
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        <Routes>
          <Route path="/*" element={<Auth />} />
        </Routes>
      </QueryParamProvider>
    </Router>
  </ApolloProvider>
);

export default Admin;

const container = document.getElementById('auth');
if (container) {
  createRoot(container).render(<Admin />);
}
